/*
 * @Author: Zhouqi
 * @Date: 2025-11-03 10:57:44
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-12-29 19:28:51
 */
import { useRouter } from 'next/router';

import { useRouteChange } from '@/hooks/useRouteChange';
import { useTranslate } from '@/hooks/useTranslate';
import { ROUTE_FROM } from '@/utils/const';
import { PageVisitFrom } from '@/utils/eventlog/eventNewConfig';
import { avatarVideoProURL, videoGenerateURL, videoTranslateURL } from '@/utils/router';

import PopularTool from './_components/popular-tool';
import { AvatarVideoIcon, FrameIcon, VideoGenerateIcon } from './icons';

const Home = () => {
  const { t } = useTranslate();
  const { navigate } = useRouteChange();
  const router = useRouter();

  const navigateTo = (url?: string) => {
    if (!url) return;
    sessionStorage.setItem(ROUTE_FROM, PageVisitFrom.HOME_CLICK);
    navigate(() => {
      router.replace(url);
    });
  };

  return (
    <div className="flex justify-center overflow-hidden no-scrollbar w-full h-full">
      <div className="flex flex-col gap-[16px] px-[32px] py-[16px] max-w-[1154px] overflow-auto">
        <span className="font-[500] text-[16px]">{t('FalcoCut')}</span>
        <div className="flex justify-between gap-[16px]">
          <div
            className="flex flex-1 items-center rounded-[18px] box-border gap-[8px] bg-[#F3EFFF] p-[16px] border-[1px] border-transparent hover:border-[#745CFF] cursor-pointer transition-colors"
            onClick={() => navigateTo(videoTranslateURL)}
          >
            <div>
              <FrameIcon />
            </div>
            <div className="flex flex-col gap-[6px]">
              <span className="text-[14px] font-[500]">
                {t('merror.translation.title')}
              </span>
              <span className="text-[12px] text-[#666666]">{t('AI--')}</span>
            </div>
          </div>
          <div
            className="flex flex-1  items-center rounded-[18px] gap-[8px] bg-[#EFF4FF] p-[16px] border-[1px] border-transparent hover:border-[#5CA5FF] cursor-pointer transition-colors"
            onClick={() => navigateTo(avatarVideoProURL)}
          >
            <div>
              <AvatarVideoIcon />
            </div>
            <div className="flex flex-col gap-[6px]">
              <span className="text-[14px] font-[500]">{t('bc.AvatarVideoPro')}</span>
              <span className="text-[12px] text-[#666666]">
                {t('e47101b2eadcba224fff5aef6688a3b7')}
              </span>
            </div>
          </div>
          <div
            className="flex flex-1  items-center rounded-[18px] box-border gap-[8px] bg-[#F3EFFF] p-[16px] border-[1px] border-transparent hover:border-[#F45CFF] cursor-pointer transition-colors"
            onClick={() => navigateTo(videoGenerateURL)}
          >
            <div>
              <VideoGenerateIcon />
            </div>
            <div className="flex flex-col gap-[6px]">
              <span className="text-[14px] font-[500]">
                {t('9a1641a16a4cc4df9ffa2a17b6348ae0')}
              </span>
              <span className="text-[12px] text-[#666666]">
                {t('aaa547885d05469e074917ab6234a7ef')}
              </span>
            </div>
          </div>
        </div>
        <span className="font-[500] text-[16px]">
          {t('3e90c5117dc0fe9d71410e448d766e52')}
        </span>
        <PopularTool />
      </div>
    </div>
  );
};

export default Home;
